import { createFileRoute, Outlet } from '@tanstack/react-router';
import './internal-tools/internal-tools.css';

export const Route = createFileRoute('/_protected/admin/internal-tools')({
  component: InternalToolsLayout,
});

/**
 * Layout component for internal tools routes.
 * Provides the special styling context (smaller text, different input styles)
 * that distinguishes internal tools from the main admin UI.
 */
function InternalToolsLayout() {
  return (
    // The pane is the scroll container for BOTH axes (h-dvh + overflow-auto),
    // not just x: an overflow-x-only value still computes overflow-y to auto,
    // which silently captures every sticky descendant into a scrollport that
    // never scrolls (the window did) — position:sticky rails were inert.
    <div id="internal-tools" className="h-dvh min-w-0 flex-1 overflow-auto bg-white">
      <Outlet />
    </div>
  );
}
